import api from './client'

export const remitosApi = {
  listar: (params) => api.get('/remitos', { params }),
  obtener: (id) => api.get(`/remitos/${id}`),
  crear: (data) => api.post('/remitos', data),
  generarPresea: (id) => api.post(`/remitos/${id}/generar-presea`),
  asignarZona: (id, data) => api.put(`/remitos/${id}/zona`, data),
  confirmar: (id) => api.post(`/remitos/${id}/confirmar`),
  cambiarTransporte: (id, transporte) => api.put(`/remitos/${id}/transporte`, { transporte }),
  anular: (id, motivo) => api.post(`/remitos/${id}/anular`, { motivo }),
  revertirAnulacion: (id) => api.post(`/remitos/${id}/revertir-anulacion`),
  verificarAnulacion: (id) => api.post(`/remitos/${id}/verificar-anulacion`),
  cancelarAnulacion: (id) => api.post(`/remitos/${id}/cancelar-anulacion`),
  despachar: (id) => api.post(`/remitos/${id}/despachar`),
  entregar: (id, motivo) => api.post(`/remitos/${id}/entregar`, motivo ? { motivo } : {}),
  // `quien` = quién pasó a buscar el pedido (nombre o DNI), opcional — queda en el remito y en el historial
  marcarRetirado: (id, opts = {}) => api.post(`/remitos/${id}/marcar-retirado`, typeof opts === 'string' ? { motivo: opts } : opts),
  reavisarRetiro: (id) => api.post(`/remitos/${id}/reavisar-retiro`),
  deshacerRetiro: (id, motivo) => api.post(`/remitos/${id}/deshacer-retiro`, motivo ? { motivo } : {}),
  disponibleRetiro: (id) => api.post(`/remitos/${id}/disponible-retiro`),
  // Cambiar la modalidad de entrega de un remito ya emitido (reparto ⇄ retiro en sucursal)
  pasarARetiro: (id, sucursal, motivo) => api.post(`/remitos/${id}/pasar-a-retiro`, { sucursal, motivo: motivo || null }),
  volverAReparto: (id, motivo) => api.post(`/remitos/${id}/volver-a-reparto`, { motivo: motivo || null }),
  liberar: (id) => api.post(`/remitos/${id}/liberar`),
  // Fraude detectado en tránsito → vuelve al depósito (31 oct 2026)
  fraudeTransito: (id, motivo) => api.post(`/remitos/${id}/fraude-transito`, { motivo }),
  mercaderiaDevuelta: (id) => api.post(`/remitos/${id}/mercaderia-devuelta`),
  entregas: (id) => api.get(`/remitos/${id}/entregas`),
  generarNe: (id, data) => api.post(`/remitos/${id}/generar-ne`, data),
  imprimir: (id) => api.post(`/remitos/${id}/imprimir`, {}, { responseType: 'blob' }),
  reimprimir: (id, motivo) => api.post(`/remitos/${id}/reimprimir`, { motivo }, { responseType: 'blob' }),
  imprimirNesMasivo: (id) => api.post(`/remitos/${id}/notas-envio/imprimir-masivo`, {}, { responseType: 'blob' }),
}

export const notasEnvioApi = {
  listar: (params) => api.get('/notas-envio', { params }),
  obtener: (id) => api.get(`/notas-envio/${id}`),
  asignarZona: (id, zona_id) => api.put(`/notas-envio/${id}/zona`, { zona_id }),
  imprimir: (id) => api.post(`/notas-envio/${id}/imprimir`),
  reimprimir: (id, motivo) => api.post(`/notas-envio/${id}/reimprimir`, { motivo }),
  entregas: (id) => api.get(`/notas-envio/${id}/entregas`),
  liberar: (id) => api.post(`/notas-envio/${id}/liberar`),
  // Envío parcial: deshace una parte sin imprimir (vuelve a pendiente).
  anularParte: (id) => api.post(`/notas-envio/${id}/anular-parte`),
  // Parte que se retira en sucursal: mismos pasos que el retiro de un remito.
  disponibleRetiro: (id) => api.post(`/notas-envio/${id}/disponible-retiro`),
  reavisarRetiro: (id) => api.post(`/notas-envio/${id}/reavisar-retiro`),
  marcarRetirado: (id, data = {}) => api.post(`/notas-envio/${id}/marcar-retirado`, data),
  deshacerRetiro: (id) => api.post(`/notas-envio/${id}/deshacer-retiro`),
  pdf: (id) => api.get(`/notas-envio/${id}/pdf`, { responseType: 'blob' }),
}

export const iaApi = {
  interpretar: (texto) => api.post('/ia/interpretar-observaciones', { texto }),
}

export const autorizacionesApi = {
  aprobar: (id) => api.put(`/autorizaciones/${id}/aprobar`),
}

// Retiros por sucursal (/logistica/retiros): la cola de cada punto de retiro
export const retirosApi = {
  listar: () => api.get('/retiros'),
}
